import moment from "moment";
import { useEffect, useState } from "react";
import { API_URL, REACT_APP_SITE_KEY } from "../../config/app-config";
import calendar from "../../img/calendar.png";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneInput from "react-phone-input-2";
import { FiArrowRight, FiSun, FiDownload, FiLock, FiCalendar, FiClock, FiZap } from "react-icons/fi";
import { FaStar, FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube, FaGlobe } from "react-icons/fa";

import "./ServiceCardThemeV6.css";

moment.locale("en");

// Calendar Component
function MonthGridCalendar({ slots, packageDays, selectedValue, onSelect }) {
  const today = moment().locale("en");
  const [viewMonth, setViewMonth] = useState(today.clone().startOf("month"));

  const availableSet = new Set((slots || []).filter((s) => s.available).map((s) => s.value));
  const slotMap = {};
  (slots || []).forEach((s) => { slotMap[s.value] = s; });

  const goMonth = (dir) => setViewMonth((prev) => prev.clone().locale("en").add(dir, "month").startOf("month"));

  const vmEn = viewMonth.clone().locale("en");
  const startDay = vmEn.clone().startOf("month").day();
  const daysInMonth = vmEn.daysInMonth();

  const cells = [];
  for (let i = 0; i < startDay; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);

  const weeks = [];
  for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7));

  const DOW = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
  const isPrevDisabled = viewMonth.clone().locale("en").isSameOrBefore(today.clone().startOf("month"));

  return (
    <div>
      <div className="monthNavRow" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <button type="button" onClick={() => goMonth(-1)} disabled={isPrevDisabled} style={{ background: 'none', border: 'none', cursor: isPrevDisabled ? 'not-allowed' : 'pointer', fontSize: '18px', color: 'var(--v6-dark)' }}>‹</button>
        <h4 style={{ margin: 0, fontSize: '12px', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.1em' }}>{vmEn.format("MMMM YYYY")}</h4>
        <button type="button" onClick={() => goMonth(1)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '18px', color: 'var(--v6-dark)' }}>›</button>
      </div>
      <table className="monthGridCalendar" style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center' }}>
        <thead>
          <tr>{DOW.map((d) => (<th key={d} style={{ padding: '8px 0', fontSize: '11px', opacity: 0.7 }}>{d}</th>))}</tr>
        </thead>
        <tbody>
          {weeks.map((week, wi) => (
            <tr key={wi}>
              {week.map((day, di) => {
                if (!day) return <td key={di}><div style={{ padding: '8px' }}></div></td>;
                const dateVal = vmEn.clone().date(day).format("YYYY/MM/DD");
                const isPast = vmEn.clone().date(day).isBefore(today, "day");
                const dayMatches = packageDays.length === 0 || packageDays.includes(moment(dateVal, "YYYY/MM/DD").locale("en").format("ddd").toUpperCase());
                const isAvail = availableSet.has(dateVal) && !isPast && dayMatches;
                const isSelected = selectedValue === dateVal;

                let btnClass = "gridDayBtn ";
                if (isSelected) btnClass += "gridSelected";
                else if (isAvail) btnClass += "gridAvailable";

                return (
                  <td key={di} style={{ padding: '4px' }}>
                    <button
                      type="button"
                      className={btnClass}
                      style={{ width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto', cursor: isAvail ? 'pointer' : 'not-allowed', opacity: isAvail || isSelected ? 1 : 0.3 }}
                      onClick={(e) => {
                        e.preventDefault();
                        if (!isAvail) return;
                        const slotObj = slotMap[dateVal];
                        if (slotObj) onSelect(slotObj);
                      }}
                    >
                      {day}
                    </button>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// Time Panel Component
function TimeSidePanel({ hasDateSelected, slots, selectedSlot, onSelect, isDisabledFn }) {
  return (
    <div className="timeSide">
      <div className="v6-section-eyebrow" style={{ marginBottom: '16px' }}>
        <FiClock size={14} style={{ marginRight: '6px', verticalAlign: 'text-bottom' }} />
        Select Time
      </div>
      {!hasDateSelected ? (
        <div style={{ opacity: 0.5, fontSize: '13px', fontWeight: 600 }}>Pick a date to see times</div>
      ) : (
        <div className="v6-twoColSlots">
          {slots.length > 0 ? (
            slots.map((item, i) => {
              const fromStr = item.from ?? "";
              const toStr = item.to ?? "";
              const fmt = fromStr.includes("AM") || fromStr.includes("PM") ? "hh:mm A" : "HH:mm";
              const displayFrom = moment(fromStr, fmt).isValid() ? moment(fromStr, fmt).format("h:mm A") : fromStr;
              const displayTo = moment(toStr, fmt).isValid() ? moment(toStr, fmt).format("h:mm A") : toStr;
              const isSelected = selectedSlot?.from === fromStr && selectedSlot?.to === toStr;
              const isDisabled = isDisabledFn ? isDisabledFn(item) : false;

              return (
                <button
                  type="button"
                  key={i}
                  className={`timeSlotBtn ${isSelected ? 'tsActive' : ''}`}
                  style={{ padding: '12px', fontSize: '13px', cursor: isDisabled ? 'not-allowed' : 'pointer', opacity: isDisabled ? 0.5 : 1 }}
                  onClick={(e) => { e.preventDefault(); if (!isDisabled) onSelect(item); }}
                >
                  {displayFrom} – {displayTo}
                </button>
              );
            })
          ) : (
            <p style={{ gridColumn: '1/-1', fontSize: '13px', opacity: 0.7, fontWeight: 600 }}>No slots available</p>
          )}
        </div>
      )}
    </div>
  );
}

// Main Component
const ServiceCardThemeV6 = ({
  data,
  selectService,
  isPreview,
  uploadDetails,
  updateState,
  confirmDetails,
  recaptcha,
  viewAvailableSlot,
  slugSelected,
  onResourceClick,
}) => {

  const eventData = data.eventData || data.eventDetails || {};
  const userDetails = data.userDetails || {};
  const resourceList = data.resource || data.resourceList || [];

  const businessLogo = isPreview
    ? eventData.businessLogo
    : eventData.businessLogo ? `${API_URL}auth/image/${eventData.businessLogo}` : calendar;

  const businessName = eventData.businessName || userDetails.userName || "Naina Kapoor";
  const displayTitle = eventData.serviceName || "MAKE SPACE TO LAND.";

  // Social Media Extractor
  const { faceBook, instagram, linkedIn, youtube, personalWebsite } = userDetails;
  const hasSocials = faceBook || instagram || linkedIn || youtube || personalWebsite;

  // --- REVIEW RANKING & FALLBACK LOGIC ---
  const fallbackQuotes = [
    "Her cues are specific without ever feeling demanding.",
    "The one appointment I protect every week.",
    "I left feeling quieter in my own body.",
    "A transformative space for both mind and body.",
    "The most intentional and restorative practice I've had in years."
  ];

  const rawReviews = data.reviewList || [];

  // Sort reviews by Top Rank (Satisfaction 5 -> 1) then by Date (Newest first)
  const sortedReviews = [...rawReviews].sort((a, b) => {
    if ((b.satisfaction || 0) !== (a.satisfaction || 0)) {
      return (b.satisfaction || 0) - (a.satisfaction || 0);
    }
    return (b.updateDate || 0) - (a.updateDate || 0);
  });

  const reviews = sortedReviews.length > 0
    ? sortedReviews.map((rev, i) => {
        const isNotGiven = !rev.suggestion || rev.suggestion === "Not given" || rev.suggestion.trim() === "";
        return {
          ...rev,
          displaySuggestion: isNotGiven ? fallbackQuotes[i % fallbackQuotes.length] : rev.suggestion,
          displayName: rev.name || "Client",
          displaySource: rev.source || (rev.type === "review" ? "Client Review" : "Google")
        };
      })
    : [
        { displayName: "Leela S.", displaySource: "Google", displaySuggestion: fallbackQuotes[0], satisfaction: 5, updateDate: Date.now() - 172800000 },
        { displayName: "Devika M.", displaySource: "ClassPass", displaySuggestion: fallbackQuotes[1], satisfaction: 5, updateDate: Date.now() - 86400000 },
        { displayName: "Priya V.", displaySource: "Featured review", displaySuggestion: fallbackQuotes[2], satisfaction: 5, updateDate: Date.now() }
      ];

  const avgRating = eventData.ratings ?? "4.9/5";

  // Slider Logic for 3-Column Client Notes Grid
  const [reviewIndex, setReviewIndex] = useState(0);

  const handleNextReview = () => {
    if (reviewIndex + 3 < reviews.length) setReviewIndex(reviewIndex + 3);
    else setReviewIndex(0);
  };
  const handlePrevReview = () => {
    if (reviewIndex - 3 >= 0) setReviewIndex(reviewIndex - 3);
    else {
      const remainder = reviews.length % 3;
      setReviewIndex(reviews.length - (remainder === 0 ? 3 : remainder));
    }
  };

  const dummyServices = [
    { serviceName: "Morning floorwork", duration: 50, amount: 1200, appointmentName: "INDIVIDUAL SESSION", description: "A personal practice shaped around your energy and experience." },
    { serviceName: "Private reset", duration: 75, amount: 2400, appointmentName: "INDIVIDUAL SESSION", description: "A focused guided session with room for questions and adjustments." }
  ];
  const rawServiceList = data.service || data.serviceList || [];
  const serviceList = rawServiceList.length > 0 ? rawServiceList : dummyServices;

  const [chosenService, setChosenService] = useState(null);
  const [isPackageSelected, setIsPackageSelected] = useState({});
  const [selectedNoteOption, setSelectedNoteOption] = useState(""); // Track the dropdown selection
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isMobile = window.screen.width < 768;

  useEffect(() => {
    if (!slugSelected || !serviceList.length) return;
    const index = serviceList.findIndex((s) => s.slug === slugSelected || String(s.id) === String(slugSelected));
    if (index !== -1) handleBookClick(serviceList[index], index);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slugSelected, serviceList]);

  // FIX 2: close the modal automatically once a booking completes.
  // The free-booking flow never toggled isModalOpen (it's local state here),
  // so the modal stayed open after a free booking succeeded. The parent
  // (CalendarVcard) flips data.bookingSuccess to true on both the free and
  // paid success paths — this effect reacts to that signal.
  useEffect(() => {
    if (data.bookingSuccess) {
      setIsModalOpen(false);
    }
  }, [data.bookingSuccess]);

  const safeParse = (value) => {
    try {
      if (!value) return [];
      const p = JSON.parse(value);
      return typeof p === "string" ? JSON.parse(p) : p;
    } catch (e) { return []; }
  };

  const packageDays = safeParse(isPackageSelected?.packageDays);
  const timeSlots = safeParse(isPackageSelected?.timeSlots) || [];

  const getAllSlots = () => {
    if (!data.availableSlot?.length) return [];
    return data.availableSlot.filter((item) => {
      if (Object.keys(data?.activeIndexData || {}).length > 0) {
        const isToday = moment(data.activeIndexData.value, "YYYY/MM/DD");
        if (isToday.isSame(moment(), "day")) {
          const curTime = moment(new Date(), "HH:mm");
          const fromTime = moment(item.from, "HH:mm");
          return fromTime.isSameOrAfter(curTime);
        }
      }
      return true;
    });
  };

  const priceLabel = (svc) => (svc?.amount == 0 ? "Free" : `₹${svc?.amount}`);
  const selectedServiceObj = chosenService !== null ? serviceList[chosenService] : null;

  const handleBookClick = (item, ind) => {
    selectService(item);
    setChosenService(ind);
    setIsPackageSelected(item);
    updateState("bookingMode", "self");
    updateState("expertNote", "");
    updateState("bookingSuccess", false); // FIX 2: clear any stale success flag from a previous booking
    setIsModalOpen(true);
  };

  const handleResourceCardClick = (res) => {
    if (isPreview) return;
    if (typeof onResourceClick === "function") onResourceClick(res);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    updateState("name", "");
    updateState("email", "");
    updateState("phoneNumber", "");
    updateState("description", "");
    updateState("detailsPage", false); // Reset back to step 1
    updateState("bookingSuccess", false); // FIX 2: keep state clean on manual close too
    setSelectedNoteOption(""); // Reset dropdown selection

    if (recaptcha?.current) {
      recaptcha.current.reset();
    }
  };

  // V6 Step Indicator
  const renderStepper = (activeStep) => (
    <div className="v6-bkStepBar">
      <div className={`v6-bkStep ${activeStep === 1 ? "active" : activeStep > 1 ? "done" : ""}`}>
        <div className="v6-bkStepCircle">{activeStep > 1 ? "✓" : "1"}</div>
        <span>Choose option</span>
      </div>
      <div className={`v6-bkStepLine ${activeStep > 1 ? "done" : ""}`} />
      <div className={`v6-bkStep ${activeStep === 2 ? "active" : activeStep > 2 ? "done" : ""}`}>
        <div className="v6-bkStepCircle">{activeStep > 2 ? "✓" : "2"}</div>
        <span>Provide details</span>
      </div>
      <div className={`v6-bkStepLine ${activeStep > 2 ? "done" : ""}`} />
      <div className={`v6-bkStep ${activeStep === 3 ? "active" : ""}`}>
        <div className="v6-bkStepCircle">3</div>
        <span>Confirmation</span>
      </div>
    </div>
  );

  // Modal Booking Flow
  const renderBookingModal = () => {
    if (!isModalOpen || chosenService === null) return null;
    const isGroupPackage = ["group_package", "one_to_one_package"].includes(isPackageSelected?.appointmentName);

    return (
      <div className="v6-modal-overlay" onClick={closeModal}>
        <div className="v6-modal-content" onClick={(e) => e.stopPropagation()}>
          <button type="button" className="v6-modal-close" onClick={closeModal}>×</button>

          {data.detailsPage ? (
            <form onSubmit={(e) => { e.preventDefault(); uploadDetails(e); }} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {renderStepper(2)}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '16px' }}>
                <h4 className="v6-section-title" style={{ margin: 0, fontSize: '24px' }}>Provide Details</h4>
                <button type="button" onClick={() => { recaptcha?.current?.reset(); updateState("detailsPage", false); }} className="v6-btn-outline" style={{ border: 'none' }}>
                  ← Back to options
                </button>
              </div>

              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '13px', fontWeight: 700, textTransform: 'uppercase' }}>Name *</label>
                <input className="input-text-input" value={data.name} type="text" placeholder="ENTER NAME" required onChange={(e) => updateState("name", e.target.value)} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '13px', fontWeight: 700, textTransform: 'uppercase' }}>Email *</label>
                <input className="input-text-input" value={data.email} type="email" placeholder="ENTER EMAIL" required onChange={(e) => updateState("email", e.target.value?.trim())} />
              </div>
              <div>
                <label style={{ display:'block', marginBottom:'8px', fontSize:'13px', fontWeight:600 }}>Phone Number *</label>
                <div style={{ marginTop: "4px" }}>
                  <PhoneInput
                    country={"in"}
                    containerClass="input-dark"
                    value={data.phoneNumber}
                    placeholder=""
                    countryCodeEditable={false}
                    onChange={(phone) => updateState("phoneNumber", phone)}
                    required
                  />
                </div>
              </div>
                 <div>
                <label style={{ display:'block', marginBottom:'8px', fontSize:'13px', fontWeight:600 }}>Notes for preparation *</label>
                <select 
                  className="input-text-input" 
                  value={selectedNoteOption}
                  required
                  onChange={(e) => {
                    setSelectedNoteOption(e.target.value);
                    if (e.target.value !== "Other") {
                      updateState("description", e.target.value);
                    } else {
                      updateState("description", "");
                    }
                  }}
                  style={{ marginBottom: selectedNoteOption === "Other" ? '12px' : '0' }}
                >
                  <option value="" disabled>Select an option</option>
                  <option value="I'm looking for general relaxation and mindfulness.">I'm looking for general relaxation and mindfulness.</option>
                  <option value="I'm dealing with specific tension/tightness and need relief.">I'm dealing with specific tension/tightness and need relief.</option>
                  <option value="I'm a beginner looking for a gentle introduction.">I'm a beginner looking for a gentle introduction.</option>
                  <option value="Other">Other (I will type my own notes)</option>
                </select>

                {selectedNoteOption === "Other" && (
                  <textarea 
                    className="input-text-input" 
                    value={data.description} 
                    required={selectedNoteOption === "Other"} 
                    placeholder="Please specify your requirements or notes here..."
                    onChange={(e) => updateState("description", e.target.value)} 
                    style={{ minHeight: '100px', resize: 'vertical' }} 
                  />
                )}
              </div>

              <div style={{ margin: "8px 0" }}>
                <ReCAPTCHA size={isMobile ? "compact" : "normal"} ref={recaptcha} sitekey={REACT_APP_SITE_KEY} />
              </div>

              <button type="submit" className="v6-btn-primary" onClick={() => confirmDetails()} style={{ alignSelf: 'flex-start' }}>
                <FiCalendar size={16} /> Book {selectedServiceObj?.serviceName} - {priceLabel(selectedServiceObj)} <FiArrowRight size={16} />
              </button>
            </form>
          ) : (
            <div>
              {renderStepper(1)}

              {!isGroupPackage && (
                <>
                  <div style={{ marginBottom: '32px', textAlign: 'center' }}>
                    <h2 className="v6-section-title" style={{ fontSize: '32px', marginBottom: '8px' }}>
                      Schedule your session
                    </h2>
                    <p style={{ opacity: 0.6, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.1em', fontSize: '13px' }}>
                      Choose how you&apos;d like to book
                    </p>
                  </div>

                  <div className="v6-bkModeRow">
                    <div className={`v6-bkModeCard ${data.bookingMode === "self" ? "bkSelected" : ""}`} onClick={() => updateState("bookingMode", "self")}>
                      <div className="v6-bkModeRadio">{data.bookingMode === "self" && <div className="v6-bkModeRadioInner" />}</div>
                      <div className="v6-bkModeText">
                        <h5>I&apos;ll pick date & time</h5>
                        <p>Select from available slots</p>
                      </div>
                    </div>

                    <div className={`v6-bkModeCard ${data.bookingMode === "expert" ? "bkSelected" : ""}`} onClick={() => updateState("bookingMode", "expert")}>
                      <div className="v6-bkModeRadio">{data.bookingMode === "expert" && <div className="v6-bkModeRadioInner" />}</div>
                      <div className="v6-bkModeText">
                        <h5>Let the expert choose</h5>
                        <p>Share your preference and expert will schedule</p>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {data.bookingMode === "expert" && !isGroupPackage && (
                <div style={{ padding: '32px', background: '#fff', border: '1px solid var(--v6-border)', marginBottom: '32px' }}>
                  <label style={{ display: 'block', marginBottom: '16px', fontSize: '14px', fontWeight: 800, textTransform: 'uppercase' }}>Share your preference / availability</label>
                  <textarea
                    className="input-text-input"
                    placeholder="e.g. I'm available weekday evenings after 6 PM IST, prefer Thursday or Friday..."
                    value={data.expertNote || ""}
                    onChange={(e) => updateState("expertNote", e.target.value)}
                    style={{ minHeight: '120px', marginBottom: '16px' }}
                  />
                  <p style={{ fontSize: '13px', opacity: 0.7, fontWeight: 600 }}>The expert will review your preference and send you a confirmed slot via email.</p>
                </div>
              )}

              {(data.bookingMode === "self" || isGroupPackage) && (
                <div className="v6-calTimeSplit">
                  <div className="v6-calSide">
                    <div className="v6-section-eyebrow" style={{ marginBottom: '16px' }}>
                      <FiCalendar size={14} style={{ marginRight: '6px', verticalAlign: 'text-bottom' }} />
                      Select Date
                    </div>
                    <MonthGridCalendar
                      slots={data.slots}
                      packageDays={isGroupPackage ? packageDays : []}
                      selectedValue={data.activeIndexData?.value}
                      onSelect={(slotObj) => {
                        const idx = data.slots?.findIndex((s) => s.value === slotObj.value);
                        viewAvailableSlot(idx ?? 0, slotObj, slotObj.available);
                      }}
                    />
                  </div>

                  <div className="v6-timeSide">
                    <div className="v6-section-eyebrow" style={{ marginBottom: '16px' }}>
                      <FiClock size={14} style={{ marginRight: '6px', verticalAlign: 'text-bottom' }} />
                      Available Time Slots
                    </div>

                    {data.activeIndexData?.value && (
                      <div className="v6-tzChip">
                        <FiClock size={11} /> {eventData.timeZone ? `Times in ${eventData.timeZone}` : "Times in IST"}
                      </div>
                    )}

                    {!data.activeIndexData?.value ? (
                      <div style={{ padding: '60px 20px', textAlign: 'center', opacity: 0.4, border: '1px dashed var(--v6-dark)' }}>
                        <FiCalendar size={40} style={{ marginBottom: '16px' }} />
                        <p style={{ fontSize: '13px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em' }}>No date selected<br /><span style={{ opacity: 0.7, fontWeight: 500, fontSize: '12px', textTransform: 'none' }}>Pick a date on the left</span></p>
                      </div>
                    ) : (
                      <div className="v6-twoColSlots">
                        {(isGroupPackage ? timeSlots : getAllSlots()).length > 0 ? (
                          (isGroupPackage ? timeSlots : getAllSlots()).map((item, i) => {
                            const fromStr = item.from ?? "";
                            const toStr = item.to ?? "";
                            const fmt = fromStr.includes("AM") || fromStr.includes("PM") ? "hh:mm A" : "HH:mm";
                            const displayFrom = moment(fromStr, fmt).isValid() ? moment(fromStr, fmt).format("h:mm A") : fromStr;
                            const displayTo = moment(toStr, fmt).isValid() ? moment(toStr, fmt).format("h:mm A") : toStr;
                            const isSelected = data.selectedSlot?.from === fromStr && data.selectedSlot?.to === toStr;
                            const isDisabled = item.slotAvailable === false;

                            return (
                              <button
                                type="button"
                                key={i}
                                className={`timeSlotBtn ${isSelected ? 'tsActive' : ''}`}
                                style={{ padding: '14px', fontSize: '13px', cursor: isDisabled ? 'not-allowed' : 'pointer', opacity: isDisabled ? 0.5 : 1, textTransform: 'uppercase', letterSpacing: '1px' }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (!isDisabled) {
                                    updateState("slotActiveIndex", isGroupPackage ? i : getAllSlots().findIndex(s => s.from === item.from));
                                    updateState("selectedSlot", item);
                                  }
                                }}
                              >
                                {displayFrom} – {displayTo}
                              </button>
                            );
                          })
                        ) : (
                          <p style={{ gridColumn: '1/-1', fontSize: '13px', opacity: 0.7, fontWeight: 700, textTransform: 'uppercase' }}>No slots available</p>
                        )}
                      </div>
                    )}

                    {!isGroupPackage && data.activeIndexData?.value && (
                      <div className="v6-sp-confirm-box">
                        <FiZap size={20} color="var(--v6-dark)" style={{ flexShrink: 0 }} />
                        <div>
                          <h6>Instant confirmation</h6>
                          <p>Your session will be confirmed immediately after booking.</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div style={{ marginTop: '48px', display: 'flex', justifyContent: 'center' }}>
                <button
                  type="button"
                  className="v6-btn-primary"
                  style={{ width: '100%', maxWidth: '400px', justifyContent: 'center' }}
                  onClick={() => isPreview ? () => {} : confirmDetails()}
                >
                  Continue to Details <FiArrowRight size={18} />
                </button>
              </div>

            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="v6-wrapper">
      <div className="v6-container">

        {/* Navigation */}
        <header className="v6-header">
          <div className="v6-logo-group">
            <span className="v6-logo-circle">
              {businessLogo && businessLogo !== calendar ? (
                <img src={businessLogo} alt="Logo" />
              ) : (
                businessName.charAt(0).toUpperCase() + (businessName.split(' ')[1]?.charAt(0).toUpperCase() || "")
              )}
            </span>
            <span>HABIT / HOUSE</span>
          </div>
          <div style={{ opacity: 0.8 }}>{eventData.specialisations?.split(',')[0] || "Yoga · Sound · Stillness"}</div>
        </header>

        {/* Hero Area */}
        <section className="v6-hero">
          <div className="v6-hero-content">
            {eventData.sliderTextTwo && (
              <div className="v6-hero-eyebrow">{eventData.sliderTextTwo}</div>
            )}

            <h1 className="v6-hero-title">
              {(eventData.sliderTextOne || displayTitle).split(' ').map((word, i) => <span key={i}>{word} <br /></span>)}
            </h1>

            <div className="v6-hero-desc" dangerouslySetInnerHTML={{ __html: eventData.description || "Weekly rituals with Naina — a little less performance, a little more presence." }} />

            {/* FIX 1: scrollIntoView instead of offsetTop-based scrollTo — offsetTop
                is relative to the nearest positioned ancestor, not the page, so any
                positioned ancestor in the tree (e.g. the modal overlay) makes it
                resolve to 0 or the wrong offset. scrollIntoView always targets the
                real element regardless of ancestor positioning. */}
            <button
              type="button"
              className="v6-btn-primary"
              onClick={() =>
                document
                  .querySelector('.v6-services-wrapper')
                  ?.scrollIntoView({ behavior: 'smooth', block: 'start' })
              }
            >
              Book your ritual ↗
            </button>

            {/* Render Social Media Links if Present */}
            {hasSocials && (
              <div className="v6-social-links">
                {personalWebsite && <a href={personalWebsite} target="_blank" rel="noreferrer" className="v6-social-icon"><FaGlobe /></a>}
                {faceBook && <a href={faceBook} target="_blank" rel="noreferrer" className="v6-social-icon"><FaFacebookF /></a>}
                {instagram && <a href={instagram} target="_blank" rel="noreferrer" className="v6-social-icon"><FaInstagram /></a>}
                {linkedIn && <a href={linkedIn} target="_blank" rel="noreferrer" className="v6-social-icon"><FaLinkedinIn /></a>}
                {youtube && <a href={youtube} target="_blank" rel="noreferrer" className="v6-social-icon"><FaYoutube /></a>}
              </div>
            )}
          </div>

          <div className="v6-hero-visual">
            <div className="v6-yellow-tag">
              {eventData.timeZone ? eventData.timeZone.split('/')[1]?.replace(/_/g, ' ') : "Worli, Mumbai"}
            </div>
            {businessLogo && businessLogo !== calendar ? (
              <div className="v6-hero-image" style={{ backgroundImage: `url(${businessLogo})` }}></div>
            ) : (
              <div className="v6-hero-image" style={{ backgroundImage: `url('https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=600')` }}></div>
            )}
          </div>
        </section>

        {/* Services Split Layout */}
        <div className="v6-services-wrapper" id="services-section">
          <div className="v6-services-left">
            <div className="v6-pink-bar"></div>
            <h2 className="v6-section-title-large">Choose your<br />way in.</h2>
          </div>

          <div className="v6-services-right">
            {serviceList.map((item, ind) => {
              return (
                <div key={ind} className="v6-service-item">
                  <div className="v6-service-header">
                    <div className="v6-service-name">{item.serviceName}</div>
                    <div className="v6-service-price">
                      {item.duration} min · {priceLabel(item)}
                    </div>
                  </div>
                  <div className="v6-service-type">
                    {item.appointmentName?.replace(/_/g, ' ').toUpperCase() || "INDIVIDUAL SESSION"}
                  </div>
                  <div className="v6-service-desc" dangerouslySetInnerHTML={{ __html: item.description }} />
                  <button type="button" className="v6-btn-outline" onClick={() => handleBookClick(item, ind)}>
                    {item.btnText || "Book this session →"}
                  </button>
                </div>
              );
            })}
          </div>
        </div>

        {/* Circle Badge above Client Notes */}
        <div className="v6-badge-wrapper">
          <div className="v6-circle-badge">
            SMALL<br />RITUALS<br />BIG PAUSES
          </div>
        </div>

        {/* Testimonial Top Banner */}
        {reviews.length > 0 && (
          <div className="v6-testimonial-banner">
            <FiSun size={22} color="var(--v6-dark)" />
            <div className="v6-banner-quote">
              “{reviews[0]?.displaySuggestion}”
            </div>
            <div className="v6-banner-stars">
              {Array.from({ length: Math.round(reviews[0]?.satisfaction || 5) }).map((_, i) => (
                <FaStar key={i} size={10} color="var(--v6-dark)" />
              ))}
            </div>
            <div className="v6-banner-author">
              {reviews[0]?.displayName} · {reviews[0]?.displaySource}
            </div>
          </div>
        )}

        {/* Client Notes Section */}
        {reviews.length > 0 && (
          <section className="v6-grid-section">
            <div className="v6-grid-header">
              <div>
                <div className="v6-section-eyebrow">CLIENT NOTES</div>
                <h2 className="v6-section-title" style={{ margin: 0 }}>What clients say about {businessName.split(' ')[0]}</h2>
              </div>
              <div style={{ fontSize: '13px', fontWeight: 800 }}>★★★★★ · {avgRating}</div>
            </div>

            <div className="v6-card-grid">
              {reviews.slice(reviewIndex, reviewIndex + 3).map((rev, idx) => (
                <div className="v6-card" key={idx}>
                  <div className="v6-review-stars">
                    {Array.from({ length: Math.round(rev.satisfaction || 5) }).map((_, i) => (
                      <FaStar key={i} size={14} color="var(--v6-dark)" />
                    ))}
                  </div>
                  <div className="v6-review-text">
                    “{rev.displaySuggestion}”
                  </div>
                  <div className="v6-review-author">
                    {rev.displayName} · {rev.displaySource}
                  </div>
                </div>
              ))}
            </div>

            {reviews.length > 3 && (
              <div className="v6-notes-controls">
                <div style={{ fontSize: '11px', opacity: 0.6, letterSpacing: '0.1em', fontWeight: 700, textTransform: 'uppercase' }}>
                  {Math.min(reviewIndex + 3, reviews.length)} OF {reviews.length}
                </div>
                <div>
                  <button type="button" className="v6-arrow-btn" onClick={handlePrevReview}>←</button>
                  <button type="button" className="v6-arrow-btn" onClick={handleNextReview}>→</button>
                </div>
              </div>
            )}
          </section>
        )}

        {/* Ready-Made Resources Section */}
        {resourceList.length > 0 && (
          <section className="v6-grid-section" id="resources-section">
            <div className="v6-grid-header">
              <div>
                <div className="v6-section-eyebrow">DIGITAL RESOURCES</div>
                <h2 className="v6-section-title" style={{ margin: 0 }}>Get instant access</h2>
              </div>
            </div>
            <div className="v6-card-grid">
              {resourceList.map((res, ind) => {
                const isResourceFree = Number(res.amount) === 0;
                const fileCount = res.resourceFiles?.length || 0;

                return (
                  <div key={res.id} className="v6-card" onClick={() => handleResourceCardClick(res)} style={{ cursor: 'pointer' }}>
                    <div className="v6-section-eyebrow" style={{ opacity: 0.7, marginBottom: '8px' }}>
                      RESOURCE {ind + 1} {fileCount > 0 && `· ${fileCount} FILE${fileCount !== 1 ? 'S' : ''}`}
                    </div>
                    <h3 className="v6-service-name" style={{ fontSize: '20px', marginBottom: '8px' }}>{res.serviceName}</h3>
                    <div className="v6-service-price" style={{ marginBottom: '16px' }}>
                      {isResourceFree ? "Free" : `₹${res.amount}`}
                    </div>
                    <div className="v6-service-desc" style={{ flex: 1 }} dangerouslySetInnerHTML={{ __html: res.description }} />
                    <button
                      type="button"
                      className="v6-btn-outline"
                      style={{ width: 'fit-content', marginTop: '16px' }}
                      onClick={(e) => { e.stopPropagation(); handleResourceCardClick(res); }}
                    >
                      {isResourceFree ? (
                        <>Download <FiDownload size={14} /></>
                      ) : (
                        <>Purchase <FiLock size={12} /></>
                      )}
                    </button>
                  </div>
                );
              })}
            </div>
          </section>
        )}

        {/* About Provider */}
        <section className="v6-about-section">
          <div className="v6-section-eyebrow" style={{ textAlign: 'left', width: '100%' }}>MEET YOUR PROVIDER</div>
          <h3 style={{ textAlign: 'left', width: '100%' }}>{businessName}</h3>
          <p style={{ textAlign: 'left', width: '100%' }}>
            {userDetails.profession?.professionName || "Naina creates small movement and sound rituals for city-dwellers in need of a pause."}
          </p>

          {eventData.specialisations && (
            <div className="v6-tag-container" style={{ justifyContent: 'flex-start', width: '100%' }}>
              {eventData.specialisations.split(',').map((spec, i) => (
                <span key={i} className="v6-tag">{spec.trim()}</span>
              ))}
            </div>
          )}

          <div style={{ marginTop: '64px', width: '100%', textAlign: 'left' }}>
            <svg width="120" height="30" viewBox="0 0 120 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.5 5 C10 12 15 20 18 20 C18 10 15 5 12.5 5 Z" fill="#e91e63" />
              <path d="M22 5 C24.5 12 19 20 16 20 C16 10 19 5 22 5 Z" fill="#e91e63" opacity="0.8" />
              <text x="32" y="21" fontFamily="Inter" fontWeight="800" fontSize="18" fill="var(--v6-dark)">Yuukke</text>
            </svg>
          </div>
        </section>

        {/* Render Booking Modal */}
        {renderBookingModal()}
      </div>
    </div>
  );
};

export default ServiceCardThemeV6;